import { Component, Input, OnChanges, OnInit } from "@angular/core";
import { getInsights, Linqset, NODE_SUPERTYPE, NODE_TYPE } from "../../common/linqset-model";
import { OrganisationService } from "../../organisation/organisation.service";

// names, each once, in the order first met
const names = (items:{name?:string}[]) => [...new Set(items.map(i => (i?.name || '').trim()).filter(n => n.length > 0))]

class ModelDetails {
    name:string
    description:string
    workspace:string
    roles:string[]
    systems:string[]
    externals:string[]
    inputs:string[]
    outputs:string[]
    outcomes:string[]
    updated:Date
    function:string
    tags:string[] = []

    constructor(linqset:Linqset, public owner:string) {
        this.name = linqset.model.name
        this.workspace = linqset.workspaceName
        this.description = linqset.model.description
        this.roles = names(linqset.nodes.filter(n => n.type === NODE_TYPE.ROLE))
        this.externals = names(linqset.nodes.filter(n => n.type === NODE_TYPE.EXTERNAL_ORGANISATION))
        this.systems = names(linqset.nodes.filter(n => n.superType === NODE_SUPERTYPE.SYSTEM))
        this.inputs = names(linqset.nodes.filter(n => getInsights(n, linqset)?.isInput))
        this.outputs = names(linqset.nodes.filter(n => getInsights(n, linqset)?.isOutput))
        this.outcomes = names(linqset.nodes.filter(n => n.superType === NODE_SUPERTYPE.OUTCOMES))

        this.updated = linqset.model.changes?linqset.model.changes.find(c => c.projectKey === linqset.workspaceKey)?.date:undefined
        this.function = linqset.model.function?.toString()

        if (linqset.model.tagKeys && linqset.organisation.modelTags) {
            this.tags = names(linqset.model.tagKeys.map(tk => ({name: linqset.organisation.modelTags.tags.find(t => t._key === tk)?.name})))
        }else if (linqset.nodeTags?.length > 0) {
            this.tags = names(linqset.nodeTags)
        }
    }

}

@Component({
    selector: 'app-model-heading',
    templateUrl: './model-heading.html',
    styleUrls: ['./model-heading.css'],
    standalone: false
})
export class ModelHeadingComponent implements OnChanges {
    @Input() linqset:Linqset
    @Input() trigger:any

    details:ModelDetails
    // the lists shown as chips, each with its label
    lists:{label:string, items:string[]}[] = []

    constructor(private organisationService:OrganisationService) {}

    ngOnChanges(): void {
        this.setModelDetails()
    }

    // whether the model's review date has passed
    reviewDue(): boolean {
        const d = this.linqset?.model?.reviewDate
        return !!d && new Date(d).getTime() < Date.now()
    }

    setModelDetails() {
        if (this.linqset) {
            const owner = this.organisationService.users?.find(u => u._key === this.linqset.model.owner)?.name || ''
            this.details = new ModelDetails(this.linqset, owner)
            this.lists = [
                {label: 'Roles', items: this.details.roles},
                {label: 'Tools and systems', items: this.details.systems},
                {label: 'Inputs', items: this.details.inputs},
                {label: 'Outputs', items: this.details.outputs},
                {label: 'Outcomes', items: this.details.outcomes},
                {label: 'Tags', items: this.details.tags},
            ]
        }
    }
}
